module.exports = __webpack_public_path__ + "static/media/lungern-plazaA-02.ad36162e.webp";